// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_02712f2b3b--arrow--naTE9"};